module.exports = __webpack_public_path__ + "media/Video 4.531e6d53.mp4";